import { render, staticRenderFns } from "./VoiceMessage.vue?vue&type=template&id=3f53a2ba&scoped=true&"
import script from "./VoiceMessage.vue?vue&type=script&lang=js&"
export * from "./VoiceMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f53a2ba",
  null
  
)

export default component.exports